// src/components/AdminMenuItem.jsx
import { useState } from "react";
import { useUser } from "@clerk/clerk-react";

// MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

// Your admin panel
import { AdminPanel } from "../../AdminPanel";

import style from "../../../css/modalAdminPanel.module.css";

export function AdminMenuToggle() {
  const { user } = useUser();
  const isAdmin = user?.publicMetadata?.roles?.includes("admin");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  if (!isAdmin) return null;

  return (
    <div>
      <p onClick={handleOpen} className={style.link}>
        Admin Panel
      </p>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="admin-panel-title"
        aria-describedby="admin-panel-description"
        slotProps={{
          backdrop: {
            className: style.backdrop,
          },
        }}
      >
        <Box className={style.modal}>
          <div className={style.header}>
            <h2 id="admin-panel-title">Admin Panel</h2>
            <IconButton
              aria-label="close admin panel"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className={style.content} id="admin-panel-description">
            <AdminPanel />
          </div>
        </Box>
      </Modal>
    </div>
  );
}
